import _  from 'lodash';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LoadingService, ForwarderService, Country, BannerSpecialityModel} from '../../../services/index';
import { Util } from '../../../utils/index';
import { Router } from '@angular/router';
import { BannerModel } from '../../../services/index'

declare var $:any;

@Component({
  selector: 'banner-detail',
  templateUrl: 'banner-detail.html'
})
export class BannerDetailComponent {

    private promotion:BannerModel;
    private _isOpen = false;

    constructor(private forwarderService: ForwarderService){}

    @Input() set banner(banner){
        if (!banner) return;
        this.promotion = banner;
    }

    @Input() set openFlag(isOpen){
        this._isOpen = true;
    }

    @Output() onRefresh:EventEmitter<any> = new EventEmitter();

    closePromotionInfo(){
        this._isOpen = false;
    }

    ngOnInit() {
      this._isOpen = false;
    }


    deletePromotion() {
      let that = this;
      $.sweetModal.confirm('프로모션을 삭제하시겠습니까?', function() {
        that.forwarderService.deletePromotion(that.promotion.corpId, that.promotion.bannerId).subscribe(
          resp => {
            if(resp.result) {
              $.sweetModal({
                content: "삭제가 완료되었습니다.",
                icon: $.sweetModal.ICON_SUCCESS
              });
            } else {
              $.sweetModal({
                content: resp.errorMsg,
                icon: $.sweetModal.ICON_WARNING
              });
            }
            that.onRefresh.emit(null);
          }
        );
      }, function() {
      });
    }
}




// WEBPACK FOOTER //
// ./src/app/containers/banner/mng/banner-detail.ts